import {
  GET_PROFILE,
  PROFILE,
  PROFILE_ERROR,
  PROFILE_SUCCESS,
  SEND_OTP_PROFILE_EMAIL,
  SEND_OTP_PROFILE_MOBILE,
  UPDATE_PROFILE,
  UPDATE_PROFILE_EMAIL_MOBILE,
  UPDATE_PROFILE_SECONDS,
} from 'redux/actions';

const INIT_STATE = {
  profile: {},
  error: '',
  success: '',
  loading: false,
  seconds: 0,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case PROFILE:
      return { ...state, profile: action.payload };
    case GET_PROFILE:
    case UPDATE_PROFILE:
    case SEND_OTP_PROFILE_MOBILE:
    case SEND_OTP_PROFILE_EMAIL:
      return {
        ...state,
        loading: true,
        error: '',
        success: '',
        seconds: 0,
      };
    case UPDATE_PROFILE_EMAIL_MOBILE:
      return {
        ...state,
        loading: true,
        error: '',
        success: '',
      };
    case UPDATE_PROFILE_SECONDS:
      return { ...state, seconds: action.payload };
    case PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        success: action.payload.message,
      };
    case PROFILE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };
    default:
      return { ...state };
  }
};
